// extracted by mini-css-extract-plugin
export default {"SongContainer":"Song_SongContainer__F1nFG","nextSong":"Song_nextSong__hWL0y","Dark":"Song_Dark__Pgfdx","test":"Song_test__ixEa5"};